import { Box } from '@chakra-ui/react';
import { useTableCellContext } from '../context';
import BenchMark from './benchMark';

const TableCellBenchmark = () => {
  const context = useTableCellContext();
  if (context.cellType === 'benchmark') {
    const {
      height,
      minHeight,
      colorPositive,
      colorNegative,
      colorCentralBar,
      percent,
      tooltipId,
      tooltipText,
      tooltipPlace,
      fontSize,
      fontFamily,
      dataTestId,
      tooltipProps,
      maxValue
    } = context;
    return (
      <Box
        display='flex'
        alignItems='center'
        height={height || '35px'}
        minHeight={minHeight || height || '35px'}
      >
        <BenchMark
          dataTestId={dataTestId}
          colorCentralBar={colorCentralBar}
          colorPositive={colorPositive}
          colorNegative={colorNegative}
          percent={percent}
          tooltipId={tooltipId}
          tooltipText={tooltipText}
          tooltipPlace={tooltipPlace}
          fontSize={fontSize}
          fontFamily={fontFamily}
          tooltipProps={tooltipProps}
          maxValue={maxValue}
        />
      </Box>
    );
  }
  return null;
};

export default TableCellBenchmark;
